package com.castly.admin.ui

import androidx.compose.runtime.*
import com.castly.admin.api.ApiClient
import com.castly.admin.ui.audiobooks.AudiobookDetailPage
import com.castly.admin.ui.audiobooks.AudiobookListPage
sealed class AudiobooksView {
    object List : AudiobooksView()
    data class Detail(val audiobookId: String) : AudiobooksView()
}

@Composable
fun AudiobooksSection(apiClient: ApiClient) {
    var currentView by remember { mutableStateOf<AudiobooksView>(AudiobooksView.List) }

    when (val view = currentView) {
        is AudiobooksView.List -> {
            AudiobookListPage(
                apiClient = apiClient,
                onAudiobookClick = { audiobookId ->
                    currentView = AudiobooksView.Detail(audiobookId)
                },
                onEditAudiobook = { audiobookId ->
                    currentView = AudiobooksView.Detail(audiobookId)
                }
            )
        }
        is AudiobooksView.Detail -> {
            AudiobookDetailPage(
                apiClient = apiClient,
                audiobookId = view.audiobookId,
                onBack = {
                    currentView = AudiobooksView.List
                }
            )
        }
    }
}
